<template>
  <div>
    <VueFinalModal
      v-model="showModal"
      :esc-to-close="true"
      @closed="closed"
      class="modal-container"
      content-class="modal-content2"
    >
      <div style="padding: 10px">
        <!-- <div class="modal-content"> -->
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11"></div>

          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            style="padding: 0; display: flex; justify-content: center"
            @click="closed"
          >
            <i class="fas fa-times-square close_modal"></i>
          </div>
        </div>
        <form-venta :promo-code="promoCode" :is-dashboard="true" />
        <!-- <form-send-link
          v-if="showModal"
          :key="componentKeyFormSendLink"
          :token-auth="tokenAuth"
        /> -->
      </div>
    </VueFinalModal>

    <VueFinalModal
      v-model="showQr"
      :esc-to-close="true"
      @closed="closeQr"
      class="modal-container"
      content-class="modal-content2"
    >
      <div
        class="modal__content"
        style="
          background-color: #0c75ba;
          justify-content: center;
          align-items: center;
          display: flex;
          flex-direction: column;
        "
      >
        <p
          style="
            text-align: center;
            font-size: 20px;
            color: white;
            font-weight: 600;
            padding: 12px 24px;
          "
        >
          Escanea el QR <br />
        </p>
        <!-- <img src="../../assets/img/Saludsa/qr.png" style="width: 250px" /> -->
        <div style="height: 200px; width: 200px; margin-bottom: 20px">
          <!-- <vue-qrcode
            value="Hello, World!"
            :options="{
              width: 200,
              color: {
                dark: '#2778c4',
                light: '#ffffff',
              },
            }"
          ></vue-qrcode> -->
          <figure class="qrcode">
            <vue-qrcode
              :value="link"
              tag="svg"
              :options="{
                errorCorrectionLevel: 'Q',
                width: 200,
              }"
            ></vue-qrcode>
            <img
              class="qrcode__image"
              src="../../assets/img/Saludsa/saludsa_icon.png"
              alt="SaludsaIcon"
            />
            <!-- <img
              class="qrcode__image"
              src="../../assets/img/Saludsa/saludsa_icon.png"
              alt="SaludsaIcon"
            /> -->
          </figure>
        </div>
        <!-- <img
          src="/Front-Saludsa/src/assets/img/Saludsa/qr.png"
          style="width: 200px; margin: 14px"
        /> -->
      </div>
    </VueFinalModal>

    <VueFinalModal
      v-model="showModal2"
      :esc-to-close="true"
      @closed="closed2"
      class="modal-container"
      content-class="modal-content"
      header-class="modal-header"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11"></div>

          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            @click="closed2"
          >
            <i class="fas fa-times-square close_modal"></i>
          </div>
        </div>

        <retiro-cash
          v-if="showModal2"
          :key="componentKeyFormRetiro"
          :user-id="userId"
          :token-auth="tokenAuth"
          :close-method="closed2"
          v-model:available-amount="balance"
        />
      </div>
    </VueFinalModal>

    <div class="row">
      <div
        class="col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12 row"
        style="padding-right: 0"
      >
        <div
          class="col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12 column"
          style="padding-right: 0"
        >
          <swiper
            :slides-per-view="4"
            :space-between="15"
            :centered-slides="false"
            :navigation="false"
            :pagination="false"
            :breakpoints="{
              200: {
                slidesPerView: 1.1,
              },
              400: {
                slidesPerView: 1.1,
              },
              550: {
                slidesPerView: 2.5,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 4,
              },
              1200: {
                slidesPerView: 4,
              },
            }"
          >
            <swiper-slide>
              <saldo
                :key="componentKeySaldos"
                v-model:loading="loadingBalance"
                v-model:balance="balance"
              />
            </swiper-slide>
            <swiper-slide>
              <total-earning
                :key="componentKeyTotalEarning"
                v-model:loading="loadingTotalEarning"
                v-model:total-earning="totalEarning"
              />
            </swiper-slide>
            <swiper-slide>
              <referidos-mes-actual
                :key="componentKeyMonthLeads"
                v-model:loading="loadingMonthLeads"
                v-model:month-leads="monthLeads"
              />
            </swiper-slide>
            <swiper-slide>
              <referidos-historicos
                :key="componentKeyHistoricalLeads"
                v-model:loading="loadingTotalLeads"
                v-model:total-leads="totalLeads"
              />
            </swiper-slide>
            <!-- <swiper-slide>
            <referidos-tercer-nivel
              :key="componentKeyTercerNivel"
              :user-id="userId"
              :token-auth="tokenAuth"
              v-model:loading="loading"
              :refreshTeam="this.refreshTeam"
              v-model:level-three-team="levelThreeTeam"
              v-model:level-three-amount="levelThreeAmount"
            />
          </swiper-slide>
          <swiper-slide>
            <referidos-cuarto-nivel
              :key="componentKeyCuartoNivel"
              :user-id="userId"
              :token-auth="tokenAuth"
              v-model:loading="loading"
              :refreshTeam="this.refreshTeam"
              v-model:level-four-team="levelFourTeam"
              v-model:level-four-amount="levelFourAmount"
            />
          </swiper-slide> -->
          </swiper>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-lg-6 col-md-6 col-xl-6"
        style="margin-bottom: 10px"
      >
        <div class="card h-100 sellCard">
          <div class="card-body">
            <h6
              style="
                font-size: 14px;
                font-weight: bold;
                margin-bottom: 20px;
                line-height: 15px;
                text-align: center;
                color: white;
              "
            >
              ¡Refiere los planes médicos de Saludsa!
            </h6>
            <div align="center">
              <button
                class="btn btn-primary btn-lg btn-venta"
                style="color: white !important; padding: 15px 25px"
                @click="registerLead"
              >
                Refiere aquí
              </button>

              <!-- <hr class="horizontal dark" style="margin-bottom: 10px" />

              <a
                href="https://www.youtube.com/watch?v=nnggM9UBwtw&ab_channel=SaludsaPro"
                target="_blank"
                ><p style="color: white">Ver tutorial de uso</p></a
              > -->
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-lg-6 col-md-6 col-xl-6 mb-3 mb-lg-0">
        <link-venta :promo-code="promoCode" :is-mobile="isMobile" />
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-3 mb-lg-0">
        <div
          class="card margin_card col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12 mb-3 mb-lg-0"
        >
          <div class="card-body">
            <Autoplay :include-roulette="canSeeRoulette" />
          </div>
        </div>
      </div>
      <div
        class="col-12 col-sm-12 col-lg-6 col-md-6 col-xl-6"
        style="overflow: auto"
      >
        <!-- Ruleta visible según flags/roulette.roles -->
        <div
          v-if="canSeeRoulette"
          class="roulette-cta-wrapper"
          @click="goToRoulette"
        >
          <button type="button" class="roulette-cta-btn">
            <span class="roulette-cta-label">¡Gira para ganar!</span>
            <span class="roulette-cta-spins-line">
              <span class="roulette-cta-spins-text">Giros:</span>
              <span v-if="loadingSpins" class="roulette-cta-spins-badge"
                >...</span
              >
              <span v-else class="roulette-cta-spins-badge">{{
                availableSpins
              }}</span>
            </span>
          </button>
          <div class="roulette-cta-wheel-wrap">
            <img :src="arrowImg" alt="" class="roulette-cta-arrow" />
            <img
              :src="ruletaImg"
              alt="Ruleta"
              class="roulette-cta-ruleta rotating-image"
            />
          </div>
        </div>
        <listado-leads
          :key="componentKeyListadoLeads"
          :user-id="userId"
          :token-auth="tokenAuth"
        />
      </div>
      <div
        class="col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12"
        v-if="!isMobile"
      >
        <div class="row">
          <div
            class="col-12 col-sm-12 col-lg-4 col-md-12 col-xl-4"
            v-if="!isMobile"
          >
            <div
              class="dashboardActionsContainer"
              style="margin-bottom: 10px; width: auto"
            ></div>
          </div>
          <!-- <div
            class="col-12 col-sm-12 col-lg-8 col-md-12 col-xl-8"
            style="margin-top: 0px; overflow: auto"
          >
            <listado-ventas
              :key="componentKeyListadoVentas"
              :user-id="userId"
              :token-auth="tokenAuth"
            />
          </div> -->
        </div>
      </div>

      <div
        class="float_qr col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12"
        style="cursor: pointer"
        @click="showQrModal"
      >
        <button class="share-qr-button">
          <!-- <svg
              width="30"
              class="my-float"
              style="margin-top: 7px; margin-left: 10px"
              height="30"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentcolor"
            >
              <path
                d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
              />
            </svg> -->

          <p class="share-qr">Compartir QR</p>
          <i
            class="fa fa-qrcode opacity-10"
            style="color: white; font-size: 32px"
          ></i>
        </button>
      </div>

      <div
        class="float_whatsapp d-none d-sm-none d-md-inline d-lg-inline d-xl-inline col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12"
      >
        <a :href="textAyuda" target="_blank">
          <div style="justify-content: space-between; display: flex">
            <svg
              width="30"
              class="my-float"
              style="margin-top: 7px; margin-left: 10px"
              height="30"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentcolor"
            >
              <path
                d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
              />
            </svg>

            <p class="dudas_txt">¿Dudas o problemas? Contácte con soporte</p>
          </div>
        </a>
      </div>

      <div
        class="d-inline d-sm-inline d-md-none d-lg-none d-xl-none col-12 col-sm-12 col-lg-12 col-md-12 col-xl-12"
      >
        <a class="float" :href="textAyuda" target="_blank">
          <svg
            width="30"
            class="my-float"
            style="margin-top: 14px"
            height="30"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentcolor"
          >
            <path
              d="M13.601 2.326A7.854 7.854.0 007.994.0C3.627.0.068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933.0 003.79.965h.004c4.368.0 7.926-3.558 7.93-7.93A7.898 7.898.0 0013.6 2.326zM7.994 14.521a6.573 6.573.0 01-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251A6.56 6.56.0 011.407 7.922c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56.0 014.66 1.931 6.557 6.557.0 011.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729.0 00-.529.247c-.182.198-.691.677-.691 1.654.0.977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z"
            />
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
import Saldo from "./Saldo.vue";
import LinkReferido from "./LinkReferido.vue";
import LinkVenta from "./LinkVenta.vue";
import ReferidosMesActual from "./ReferidosMesActual.vue";
import ReferidosHistoricos from "./ReferidosHistoricos.vue";
import TotalEarning from "./TotalGanancias.vue";
import RegistroReferido from "./RegistroReferido.vue";
import ListadoLeads from "./ListadoLeads.vue";
import FormSendLink from "../FormSendLink.vue";
import RetiroCash from "./RetiroCash.vue";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import Autoplay from "../Dashboard/Carousel.vue";
import FormVenta from "../FormVenta.vue";
import { JSEncrypt } from "jsencrypt";
import keys from "@/store/keys";

export default {
  name: "dashboard-default",
  data() {
    let datos = JSON.parse(localStorage.getItem("userData")) || {};

    return {
      showModal: false,
      showModal2: false,
      showQr: false,
      isMobile: this.$isMobile,
      // isMobile: true,
      loading: false,
      componentKeySaldos: 0,
      componentKeyMonthLeads: 100,
      componentKeyHistoricalLeads: 200,
      componentKeyBalance: 200,
      componentKeyListadoVentas: 500,
      componentKeyFormSendLink: 600,
      componentKeyFormRetiro: 700,
      componentKeyTotalEarning: 800,
      componentKeyListadoLeads: 900,
      promoCode: datos.promoCode || "",
      userId: datos.userId || "",
      displayName: datos.displayName || "",
      tokenAuth: datos.tokenAuth || "",
      mySales: 0,
      activeSalesQuantity: 0,
      balance: 0,
      totalEarning: 0,
      monthLeads: 0,
      totalLeads: 0,
      loadingTotalEarning: true,
      loadingMonthLeads: true,
      loadingTotalLeads: true,
      loadingBalance: true,
      // link: window.location.host + "/venta/" + datos.promoCode,
      link: "https://referidos.saludsa.com/venta/" + (datos.promoCode || ""),
      availableSpins: 0,
      loadingSpins: false,
      arrowImg: require("@/assets/img/Saludsa/arrow.webp"),
      ruletaImg: require("@/assets/img/Saludsa/ruleta-no-background.webp"),
      isAdmin: false,
      isSaludsa: false,
      isUser: false,
      /** Rol en claro: solo desde `localStorage.session` desencriptado */
      userRole: null,
      rouletteFlag: null,
      rouletteFlagLoaded: false,
      textAyuda:
        "https://api.whatsapp.com/send?phone=593979665549&text=Hola,%20soy%20" +
        (datos.displayName || "").trim() +
        "%20y%20deseo%20obtener%20ayuda%20en%20Saludsa%20Refiere%20y%20Gana",
    };
  },
  components: {
    Saldo,
    VueFinalModal,
    FormSendLink,
    LinkReferido,
    LinkVenta,
    RegistroReferido,
    ReferidosMesActual,
    ReferidosHistoricos,
    TotalEarning,
    ListadoLeads,
    RetiroCash,
    Swiper,
    SwiperSlide,
    Autoplay,
    FormVenta,
  },
  computed: {
    canSeeRoulette() {
      if (!this.rouletteFlagLoaded) return false;
      const roles = Array.isArray(this.rouletteFlag?.roles)
        ? this.rouletteFlag.roles
        : [];
      return !!(this.userRole && roles.includes(this.userRole));
    },
  },
  beforeMount() {
    // Validate userData before mounting
    const userData = localStorage.getItem("userData");
    if (!userData) {
      console.log("[Dashboard] No userData found, redirecting to login");
      this.$router.push("/login");
      return;
    }

    try {
      const parsedUserData = JSON.parse(userData);
      const hasCompleteData =
        parsedUserData.birthDate ||
        parsedUserData.phone ||
        parsedUserData.balance !== undefined ||
        parsedUserData.bankUser ||
        parsedUserData.userId ||
        parsedUserData.promoCode;

      if (!hasCompleteData) {
        console.log(
          "[Dashboard] Incomplete userData found, redirecting to login",
        );
        localStorage.removeItem("userData");
        this.$router.push("/login");
        return;
      }

      console.log(
        "[Dashboard] Valid userData found, proceeding with dashboard",
      );
      this.decryptedRole();
    } catch (error) {
      console.error("[Dashboard] Error parsing userData:", error);
      localStorage.removeItem("userData");
      this.$router.push("/login");
      return;
    }
  },
  methods: {
    decryptedRole() {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          this.isAdmin = false;
          this.isSaludsa = false;
          this.isUser = false;
          this.userRole = null;
          return;
        }
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(keys.privateKeyBackoffice);
        const role = decrypt.decrypt(session);
        const roleStr = typeof role === "string" ? role.trim() : "";
        this.isAdmin = roleStr === "admin";
        this.isSaludsa = roleStr === "saludsa";
        this.isUser = roleStr === "user";
        this.userRole = roleStr || null;
      } catch (error) {
        console.error("[Dashboard] Error decrypting role:", error);
        this.isAdmin = false;
        this.isSaludsa = false;
        this.isUser = false;
        this.userRole = null;
      }
    },
    async loadRouletteFlag() {
      this.rouletteFlagLoaded = false;
      try {
        const res = await this.$https.get("/flags/roulette");
        if (res?.data?.code === 200) {
          this.rouletteFlag = res.data.data;
        } else {
          this.rouletteFlag = { roles: [] };
        }
      } catch (e) {
        this.rouletteFlag = { roles: [] };
      } finally {
        this.rouletteFlagLoaded = true;
      }
    },
    goToRoulette() {
      if (!this.canSeeRoulette) return;
      this.$router.push({ name: "premios" });
    },
    async loadSpins() {
      this.loadingSpins = true;
      try {
        const response = await this.$https.get("/balance/spins");
        if (response.data.code === 200) {
          this.availableSpins = response.data.spins ?? 0;
        } else {
          this.availableSpins = 0;
        }
      } catch (error) {
        console.error("Error al cargar giros:", error);
        this.availableSpins = 0;
      } finally {
        this.loadingSpins = false;
      }
    },
    registerLead() {
      // this.$swal({
      //   title:
      //     "Recuerda que para poder visualizar a tu referido, es necesario que este complete su registro.",
      //   icon: "info",
      //   showCancelButton: true,
      //   confirmButtonText: "OK",
      //   cancelButtonText: "CANCELAR",
      //   showConfirmButton: true,
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //     cancelButton: "btn btn-outline-secondary ml-1",
      //   },
      //   buttonsStyling: false,
      //   showLoaderOnConfirm: true,
      //   preConfirm: () => {},
      // }).then((result) => {
      //   if (result.isConfirmed) {
      //     this.$eventBus.emit("showModalVenta");
      //   }
      // });
      this.$eventBus.emit("showModalVenta");
    },
    showQrModal() {
      this.showQr = true;
    },

    closed() {
      this.$eventBus.emit("reiniciarFormVentaDashboard");
      this.showModal = false;
    },

    closed2() {
      this.$eventBus.emit("ReiniciarRetiroCash");
      this.showModal2 = false;
    },

    closeQr() {
      this.showQr = false;
    },

    copyInputValue(model) {
      const inputElement = document.getElementById(model);
      inputElement.select();
      document.execCommand("copy");
      inputElement.setSelectionRange(0, 0);
      this.$toast.success("Link Copiado exitosamente", {
        position: "top-right",
        max: 10,
      });
    },
    getTotalLeads() {
      this.loadingTotalLeads = true;
      this.$https
        .post("/leads/getTotalLeads", {
          userId: this.userId,
        })
        .then((response) => {
          this.totalLeads = response.data.allLeads;
          this.loadingTotalLeads = false;
        })
        .catch((error) => {
          if (error.response.data.code !== 500) {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loadingTotalLeads = false;
        });
    },
    getMonthLeads() {
      this.loadingMonthLeads = true;
      this.$https
        .post("/leads/getMonthLeads", {
          userId: this.userId,
        })
        .then((response) => {
          this.monthLeads = response.data.monthLeads;
          this.loadingMonthLeads = false;
        })
        .catch((error) => {
          if (error.response.data.code !== 500) {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loadingMonthLeads = false;
        });
    },

    getHistoricalEarning() {
      this.loadingTotalEarning = true;
      this.$https
        .post("/balance/getHistoricalEarning", {
          userId: this.userId,
        })
        .then((response) => {
          this.totalEarning = response.data.totalEarning;
          this.loadingTotalEarning = false;
        })
        .catch((error) => {
          if (error.response.data.code !== 500) {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loadingTotalEarning = false;
        });
    },

    getBalance() {
      this.loadingBalance = true;
      this.$https
        .post("/balance/getBalance", {
          userId: this.userId,
        })
        .then((response) => {
          this.balance = response.data.balance ? response.data.balance : 0;
          this.loadingBalance = false;
        })
        .catch((error) => {
          if (error.response.data.code !== 500) {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
          }
          this.loadingBalance = false;
        });
    },

    handleReiniciarFormVentaDashboard() {
      this.componentKeyFormSendLink += 1;
    },

    handleReiniciarListadoLeads() {
      this.componentKeyListadoLeads += 1;
    },

    handleRefreshTotalEarning() {
      this.componentKeyTotalEarning += 1;
      this.getHistoricalEarning();
    },

    handleRefreshMonthLeads() {
      this.componentKeyMonthLeads += 1;
      this.getMonthLeads();
    },

    handleRefreshHistoricalLeads() {
      this.componentKeyHistoricalLeads += 1;
      this.getTotalLeads();
    },

    handleRefreshBalance() {
      this.componentKeyBalance += 1;
      this.getBalance();
    },

    handleReiniciarRetiroCash() {
      this.componentKeyFormRetiro += 1;
    },

    handleCloseModalSendLink() {
      this.showModal = false;
    },

    handleShowModalVenta() {
      this.showModal = true;
    },

    //Retirar Cash

    handleCloseModalRetiro() {
      this.showModal2 = false;
    },

    handleReiniciarListadoVentas() {
      this.componentKeyListadoVentas += 1;
    },

    handleShowModalRetiro() {
      this.showModal2 = true;
    },

    handleReiniciarListadoVentas() {
      this.componentKeyListadoVentas += 1;
    },
    handleReiniciarSaldos() {
      this.componentKeySaldos += 1;
      this.getBalance();
    },
  },
  created() {},
  beforeUnmount() {
    try {
      this.$eventBus.off(
        "reiniciarFormVentaDashboard",
        this.handleReiniciarFormVentaDashboard,
      );
    } catch (error) {
      console.error(
        'Error removing "reiniciarFormVentaDashboard" listener:',
        error,
      );
    }

    try {
      this.$eventBus.off("refreshTotalEarning", this.handleRefreshTotalEarning);
    } catch (error) {
      console.error('Error removing "refreshTotalEarning" listener:', error);
    }

    try {
      this.$eventBus.off("refreshMonthLeads", this.handleRefreshMonthLeads);
    } catch (error) {
      console.error('Error removing "refreshMonthLeads" listener:', error);
    }

    try {
      this.$eventBus.off(
        "refreshHistoricalLeads",
        this.handleRefreshHistoricalLeads,
      );
    } catch (error) {
      console.error('Error removing "refreshHistoricalLeads" listener:', error);
    }

    try {
      this.$eventBus.off("refreshBalance", this.handleRefreshBalance);
    } catch (error) {
      console.error('Error removing "refreshBalance" listener:', error);
    }

    try {
      this.$eventBus.off("ReiniciarRetiroCash", this.handleReiniciarRetiroCash);
    } catch (error) {
      console.error('Error removing "ReiniciarRetiroCash" listener:', error);
    }

    try {
      this.$eventBus.off("closeModalSendLink", this.handleCloseModalSendLink);
    } catch (error) {
      console.error('Error removing "closeModalSendLink" listener:', error);
    }

    try {
      this.$eventBus.off("showModalVenta", this.handleShowModalVenta);
    } catch (error) {
      console.error('Error removing "showModalVenta" listener:', error);
    }

    try {
      this.$eventBus.off("closeModalRetiro", this.handleCloseModalRetiro);
    } catch (error) {
      console.error('Error removing "closeModalRetiro" listener:', error);
    }

    try {
      this.$eventBus.off("showModalRetiro", this.handleShowModalRetiro);
    } catch (error) {
      console.error('Error removing "showModalRetiro" listener:', error);
    }

    try {
      this.$eventBus.off(
        "reiniciarListadoVentas",
        this.handleReiniciarListadoVentas,
      );
    } catch (error) {
      console.error('Error removing "reiniciarListadoVentas" listener:', error);
    }

    try {
      this.$eventBus.off("reiniciarSaldos", this.handleReiniciarSaldos);
    } catch (error) {
      console.error('Error removing "reiniciarSaldos" listener:', error);
    }

    try {
      this.$eventBus.off(
        "reiniciarListadoLeads",
        this.handleReiniciarListadoLeads,
      );
    } catch (error) {
      console.error('Error removing "reiniciarSaldos" listener:', error);
    }
  },

  activated() {
    if (this.isMobile) {
      this.$eventBus.emit("activeShowMenu");
    }
  },
  deactivated() {
    // console.log("About has been deactivated");
  },

  async mounted() {
    this.decryptedRole();
    await this.loadRouletteFlag();
    this.getBalance();
    this.getHistoricalEarning();
    this.getMonthLeads();
    this.getTotalLeads();
    if (this.canSeeRoulette) {
      this.loadSpins();
    }
    this.$eventBus.on(
      "reiniciarFormVentaDashboard",
      this.handleReiniciarFormVentaDashboard,
    );
    this.$eventBus.on(
      "reiniciarListadoLeads",
      this.handleReiniciarListadoLeads,
    );
    this.$eventBus.on("refreshTotalEarning", this.handleRefreshTotalEarning);
    this.$eventBus.on("refreshMonthLeads", this.handleRefreshMonthLeads);
    this.$eventBus.on(
      "refreshHistoricalLeads",
      this.handleRefreshHistoricalLeads,
    );
    this.$eventBus.on("refreshBalance", this.handleRefreshBalance);
    this.$eventBus.on("ReiniciarRetiroCash", this.handleReiniciarRetiroCash);
    this.$eventBus.on("closeModalSendLink", this.handleCloseModalSendLink);
    this.$eventBus.on("showModalVenta", this.handleShowModalVenta);

    //Retirar Cash
    this.$eventBus.on("closeModalRetiro", this.handleCloseModalRetiro);
    this.$eventBus.on("showModalRetiro", this.handleShowModalRetiro);
    this.$eventBus.on(
      "reiniciarListadoVentas",
      this.handleReiniciarListadoVentas,
    );
    this.$eventBus.on("reiniciarSaldos", this.handleReiniciarSaldos);
  },
};
</script>

<style scoped>
.roulette-cta-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 1rem;
  cursor: pointer;
  padding-top: 12px;
}

.roulette-cta-btn {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.6rem 1rem;
  background: linear-gradient(135deg, #0075d2 0%, #005a9e 100%);
  border-radius: 1rem;
  box-shadow: 0 4px 14px rgba(0, 117, 210, 0.35);
  border: none;
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
  width: 100%;
}
.roulette-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 117, 210, 0.45);
}

.roulette-cta-label {
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
}

.roulette-cta-spins-line {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.roulette-cta-spins-badge {
  display: inline-block;
  padding: 0.2rem 0.45rem;
  font-size: 0.95rem;
  font-weight: 700;
  color: #c41230;
  background: #fff;
  border: 2px solid #c41230;
  border-radius: 6px;
  line-height: 1.2;
}

.roulette-cta-spins-text {
  font-size: 0.85rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.95);
}

/* Ruleta fuera del botón, a poca distancia */
.roulette-cta-wheel-wrap {
  position: relative;
  margin-left: 10px;
  flex-shrink: 0;
  width: 70px;
  height: 70px;
}

.roulette-cta-arrow {
  position: absolute;
  height: 22px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  top: -12px;
}

.roulette-cta-ruleta {
  height: 70px;
  width: 70px;
  display: block;
}

.rotating-image {
  animation: roulette-spin 2s linear infinite;
}

@keyframes roulette-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}
</style>
